import React, { useCallback } from 'react'
import IcomoonReact from 'icomoon-react'
import useUpdateSessionStatus from 'src/queries/sessions/useUpdateSessionStatus'
import variables from 'src/assets/styles/variables.module.scss'
import {
  diffInDaysFromNow
} from 'src/utils/helpers/SessionHelperMethods'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import Button from 'src/components/Elements/Button'

const SessionRegButton = ({ attendee, currentEvent, detailView, session }) => {
  const { mutate, isPending } = useUpdateSessionStatus()
  let buttonColor = 'lightBase'
  let icon = 'Controls-Add'
  let text = 'Add to My Schedule'
  let disabled = false
  let visible = currentEvent.event_agenda_status_key === 'event_agenda_status_full_agenda'

  if (session.session_type_key === 'session_type_one_to_one_meeting') {
    if (
      attendee.registration_status_code_key !== 'registration_status_approved'
    ) {
      return (visible = false)
    }
    const diffInDays = diffInDaysFromNow(currentEvent.event_epoch_start_time)
    // event hasn't ended yet
    if (diffInDays >= 0) {
      if (
        currentEvent?.p2p_information
          ?.external_1_on_1_platform_selections_is_complete
      ) {
        icon = ''
        text = 'Update Peer-to-Peer Meetings'
      } else {
        icon = 'Settings'
        text = 'Set Up Peer-to-Peer'
      }
    } else {
      if (session?.registration_status === 'un_register') {
        buttonColor = 'lightActive'
        icon = 'Tick'
        text = 'On My Schedule'
        disabled = true
      }
    }
  } else {
    switch (session?.registration_status) {
      case 'un_register':
        buttonColor = 'lightActive'
        text = 'On My Schedule'
        icon = 'Tick'
        break
      case 'spaces_available':
        text = 'Spaces Available'
        break
      case 'session_full':
        buttonColor = 'errorGraphic'
        text = 'Session Full'
        icon = 'Delete'
        disabled = true
        break
      case 'not_authorized':
        icon = 'Alert'
        text = 'Approval Required'
        disabled = true
        break
      default:
        break
    }
  }

  const handleButtonClick = useCallback(() => {
    if (session.session_type_key === 'session_type_one_to_one_meeting') {
      const callbackUrl = window.location
      window.open(
        `${currentEvent.p2p_information.external_1_on_1_platform_wizard_url}?wizard_from=web&callback=${callbackUrl}`,
        '_blank'
      )
    } else {
      mutate({ sessionId: session.id })
    }
  }, [session])

  if (!visible) {
    return <div></div>
  }

  return (
    <Button
      data-testid='regButton'
      label={text}
      size={detailView ? 'med' : 'small'}
      onClick={handleButtonClick}
      color={buttonColor}
      disabled={disabled || isPending}
      id={`sessionRegBtn-${session.id}`}
      iconRight={icon !== '' && (
        <IcomoonReact
          color={variables.white}
          size={detailView ? 16 : 12}
          icon={icon}
          iconSet={rebrandIconSet}
        />
      )}
    />
  )
}

export default SessionRegButton
